module.exports = __webpack_public_path__ + "static/media/measure4.af01c249.png";